import { noop } from "lodash";
import { t } from "@/i18n-js/instance";
import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import { AccessGroupContentSpecs } from "@circle-react/components/shared/AccessRegistry/AccessGroupContentSpecs";
import type { AccessGroupType } from "@circle-react/types/AccessGroup";
import { ConfirmationModal } from "@circle-react-shared/ModalsV2/ConfirmationModal";
import { Typography } from "@circle-react-shared/uikit/Typography";
import type { ConfirmationDetailsProps } from "./types";

export interface ChangesConfirmationModalProps {
  accessGroup: AccessGroupType;
  confirmationDetails: ConfirmationDetailsProps;
  modalTitle: string;
  onConfirm: () => void;
}

const ChangesConfirmationModalComponent = ({
  onConfirm = noop,
  confirmationDetails,
  accessGroup,
  modalTitle,
}: ChangesConfirmationModalProps) => {
  const modal = useModal();
  const { bodyI18nRoot, body, title } = confirmationDetails;
  const confirmationText = bodyI18nRoot
    ? t([bodyI18nRoot], {
        count: accessGroup.space_ids.length,
      })
    : body;

  return (
    <ConfirmationModal
      isOpen={modal.visible}
      onClose={modal.hide}
      onConfirm={() => {
        onConfirm();
        void modal.hide();
      }}
      confirmVariant="circle"
      title={modalTitle}
    >
      <Typography.BodyMd>{confirmationText}</Typography.BodyMd>
      <div className="mt-4">
        <AccessGroupContentSpecs accessGroupId={accessGroup.id} title={title} />
      </div>
    </ConfirmationModal>
  );
};

const ChangesConfirmationModal = ModalManager.create(
  (props: ChangesConfirmationModalProps) => (
    <ChangesConfirmationModalComponent {...props} />
  ),
);

export const useChangesConfirmationModal = () =>
  useModal(ChangesConfirmationModal);
